<p-dialog [(visible)]="dialogVisible" [modal]="true" [closable]="false" [showHeader]="false"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ maxWidth: '500px' }" styleClass="black-bg-dialog"
  appendTo="body">
  <ng-template pTemplate="content">
    <app-global-consent-form [enableDataConsent]="true" />
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex flex-column -mt-3 justify-content-between align-items-center">
      <button pButton pRipple (click)="onConfirm()" label="Sign Up" class="m-0 w-full"></button>
      <button pButton pRipple (click)="onCancel()" label="Cancel" [outlined]="true" severity="secondary"
        class="mt-2 w-full white-btn"></button>
    </div>
  </ng-template>
</p-dialog>